/** Temporary containment: do not offer a manual reset or a blanket recovery action. */
export function PasswordRecoveryNotice() {
  return (
    <section aria-label="Password recovery guidance" className="rounded-xl border border-amber-500/30 bg-amber-500/10 p-4 text-sm">
      <h3 className="font-semibold text-foreground">Manual password resets are temporarily unavailable</h3>
      <p className="mt-2 text-muted-foreground">
        Direct-login users can use Forgot password on their organisation’s login page,
        or an authorised administrator can use the existing Resend email action.
      </p>
      <p className="mt-2 text-muted-foreground">
        WordPress SSO users must recover access through WordPress. Do not use platform
        recovery emails or Resend to change their password, including your own account:
        this can break WordPress SSO sign-in.
      </p>
    </section>
  );
}
